import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { deleteMspCwmIntegrationSuccess } from '../credentials/actions';
import * as actions from './actions';
import { MspCwmMapping } from './model';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'mspCwmMappings';

export interface State extends EntityState<MspCwmMapping>, Status {}

export const adapter = createEntityAdapter<MspCwmMapping>({
    selectId: (item) => item.tenantId,
});

export const initialState: State = adapter.getInitialState({
    ...initialStatus,
});

export const reducer = createReducer(
    initialState,
    on(actions.loadMspCwmMappings, (state) => ({ ...state, loading: true })),
    on(actions.loadMspCwmMappingsSuccess, (state, action) =>
        adapter.setAll(action.items, { ...state, loaded: true, loading: false }),
    ),
    on(actions.loadMspCwmMappingsFailure, (state, { error }) => ({ ...state, error, loading: false })),
    on(actions.updateMspCwmMappings, (state) => ({ ...state, updating: true })),
    on(actions.updateMspCwmMappingsSuccess, (state, action) =>
        adapter.setAll(action.items, { ...state, updating: false, loaded: true }),
    ),
    on(actions.updateMspCwmMappingsFailure, (state, { error }) => ({ ...state, error, updating: false })),
    on(deleteMspCwmIntegrationSuccess, () => initialState),
);

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
